import { DataTable, DataTablePagination } from "@/src/components/ui/data-table";
import { fetch } from "@/src/lib/fetch";
import { useEffect, useState } from "react";
import { Operator } from "./model";
import { regionsColumns } from "./operatorsColumns";
import { usePageSize, useSearch } from "./state";
import { useNavigate } from "react-router-dom";
import { OperatorDetailsModal } from "./OperatorDetailsModal";

type OperatorsData = {
  data: Operator[];
} & DataTablePagination;

export function OperatorsTable() {
  const [loading, setLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [operatorId, setOperatorId] = useState<Operator["id"] | null>(null);
  const [operators, setOperators] = useState<OperatorsData>({
    data: [],
    total: 1,
    pagination: { page: 1, pageSize: 1 },
  });
  const [page, setPage] = useState(1);

  const navigate = useNavigate();
  const search = useSearch();

  const pageSize = usePageSize();

  useEffect(() => {
    const fetchOperators = (page: number) =>
      fetch<OperatorsData>(`/api/operators/operators?page=${page}&pageSize=${pageSize}&filter=${search}`);
    setLoading(true);
    fetchOperators(page).then((data) => {
      setOperators(data);
      setLoading(false);
    });
  }, [page, pageSize, search]);

  return (
    <div className="rounded-md bg-white border">
      <DataTable
        columns={regionsColumns}
        data={operators.data}
        pagination={operators}
        onPageClick={(p) => setPage(p)}
        onRowClick={(r) => {
          setOperatorId(r.id);
          setOpen(true);
        }}
        isLoading={loading}
      />
      <OperatorDetailsModal setOpen={setOpen} id={operatorId} open={open} />
    </div>
  );
}
